window.ENVIRONMENTS = {
    local: {
        hostTest: 'localhost',
        apiHost: 'https://linkbiwebapi-dev.azurewebsites.net',
        apiPrefix: '',
        debug: true,
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    test: {
        hostTest: 'linkbiwebappdevstorage.z6.web.core.windows.net',
        apiHost: 'https://linkbiwebapi-dev.azurewebsites.net',
        apiPrefix: '',
        debug: true,
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    development: {
        hostTest: 'linkbidev.azureedge.net',
        apiHost: 'https://linkbiwebapi-dev.azurewebsites.net',
        apiPrefix: '',
        debug: true,
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    beta: {
        hostTest: 'linkbibeta-haffb8d5afezebg3.z01.azurefd.net',
        apiHost: 'https://api.pvhlink.com',
        apiPrefix: '',
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    betaTest: {
        hostTest: 'linkbiwebappbetastorage.z6.web.core.windows.net',
        apiHost: 'https://api.pvhlink.com',
        apiPrefix: '',
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    production: {
        hostTest: 'bi.pvhlink.com',
        apiHost: 'https://api.pvhlink.com',
        apiPrefix: '',
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    },
    production_alt: {
        hostTest: 'portal.linkbi.cloud',
        apiHost: 'https://api.pvhlink.com',
        apiPrefix: '',
        maps: 'X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0'
    }
};

// Default
window.apiHost = 'https://linkbiwebapi-dev.azurewebsites.net';
window.apiPrefix = '';// e.g. /v1

const configs = Object.keys(window.ENVIRONMENTS);
const env = window.location.protocol + '//' + window.location.hostname;

configs.forEach((key) => {
    if( window.ENVIRONMENTS[key].hostTest &&
        window.ENVIRONMENTS[key].hostTest.length > 0 &&
        env.indexOf(window.ENVIRONMENTS[key].hostTest) >= 0) {
        window.debug = window.ENVIRONMENTS[key].debug;
        window.apiHost = window.ENVIRONMENTS[key].apiHost;
        window.apiPrefix = window.ENVIRONMENTS[key].apiPrefix;
        window.maps = window.ENVIRONMENTS[key].maps;
    }
});